import type { FaireProductEntity } from "../../entity_types/product";

export const p_g242z998ff: FaireProductEntity = {
  token: "p_g242z998ff",
  type: "product",
  name: "All Occasion Greeting Cards / Funny Birthday - Assorted (A3)",
  brandName: "Katie Doodle | Boutique Greeting Cards & Birthday Gifts",
  imageUrl:
    "https://cdn.faire.com/fastly/9f985f98da7551d31084fcc4a4a3cded7539450c071d686a2f101afef0b1eaca.jpeg",
  priceDollars: 2.49,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/3237851fb6867257baab0dae8d2efefffd09a28ead7ca2d90ea82b8a04c7b982.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
